import { render, staticRenderFns } from "./MaSvgRegion.vue?vue&type=template&id=041faaf7&scoped=true"
import script from "./MaSvgRegion.vue?vue&type=script&lang=js"
export * from "./MaSvgRegion.vue?vue&type=script&lang=js"
import style0 from "./MaSvgRegion.vue?vue&type=style&index=0&id=041faaf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041faaf7",
  null
  
)

export default component.exports